<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card outlined>
          <v-card-title>
            History Paket
          </v-card-title>
          <v-card-text>
            <v-simple-table>
              <thead>
                <tr>
                  <th>Nama Paket</th>
                  <th>Sisa Sesi</th>
                  <th>Total Sesi</th>
                  <th>Personal Trainer</th>
                  <th>Fitness Consultant</th>
                  <th>Tanggal Mulai</th>
                  <th>Tanggal Expired</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="packages.length === 0">
                  <td colspan="7" class="text-center">Belum ada history paket</td>
                </tr>
                <tr v-for="(item, index) in packages" :key="index">
                  <td>{{ item.package?.name || '-' }}</td>
                  <td>{{ item.remaining_session ?? 0 }}</td>
                  <td>{{ item.total_session ?? 0 }}</td>
                  <td>{{ item.personal_trainer?.name || '-' }}</td>
                  <td>{{ item.fitness_consultant?.name || item.fitness_consultant_name || '-' }}</td>
                  <td>{{ formatDate(item.start_date) }}</td>
                  <td>{{ formatDate(item.expired_date) }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ApiService from "@/core/services/api.service";
import moment from "moment";

export default {
  data() {
    return {
      packages: [],
    };
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  async mounted() {
    await this.fetchPackages();
  },
  methods: {
    async fetchPackages() {
      const response = await ApiService.get(
        `sales/list-item-expired?member_id=${this.id}`
      );
      const payload = response?.data;
      this.packages = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.rows)
          ? payload.rows
          : [];
    },
    formatDate(date) {
      if (!date) return "-";
      return moment(date).format("dddd, DD MMMM YYYY");
    },
  },
};
</script>

<style scoped>
.v-card-title {
  font-weight: bold;
}
</style>
